import { Component } from 'react';

import NotFound from 'components/NotFound';
import AllClinicalNotes from 'components/practice/charts/ClinicalNote/AllClinicalNotes/AllClinicalNote';
import ClinicalNote from 'components/practice/charts/ClinicalNote/ClinicalNote';
import CurrentNote from 'components/practice/charts/ClinicalNote/CurrentNote/CurrentNote';
import MyScribeAI from 'components/practice/charts/ClinicalNote/MyScribeAI/MyScribeAI';
import AmbientListening from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/AmbientListening/AmbientListening';
import EnhanceNote from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/EnhanceNote/EnhanceNote';
import MyOwnTemplate from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/MyOwnTemplate/MyOwnTemplate';
import MyScribeTemplate from 'components/practice/charts/ClinicalNote/MyScribeAI/Templates/MyScribeTemplate/MyScribeTemplate';

const PRACTICE_CHARTS_CLINICAL_NOTES = [
  {
    path: 'clinical-notes',
    element: <AllClinicalNotes />,
    children: [
      {
        path: ':appointmentId',
        element: <ClinicalNote />,
        children: [
          {
            element: <CurrentNote />,
            children: [
              {
                path: ':type',
                element: <Component />,
                children: [
                  {
                    path: ':formName',
                    element: <Component />
                  }
                ]
              }
            ]
          },
          {
            path: 'myscribe-ai',
            element: <MyScribeAI />,
            children: [
              {
                path: 'map-my-own-template',
                element: <MyOwnTemplate />
              },
              {
                path: 'automap',
                element: <MyScribeTemplate />
              },
              {
                path: 'ambient-listening',
                element: <AmbientListening />
              },
              {
                path: 'enhance-current-note',
                element: <EnhanceNote />
              },
              {
                path: '*',
                element: <NotFound />
              }
            ]
          }
        ]
      }
    ]
  }
];

export default PRACTICE_CHARTS_CLINICAL_NOTES;
